import view from '../mixins/view';
export default {
  name: 'SelectPageList',
  mixins: [view],
  render: function render(h) {
    var _this = this;

    return h('ul', {
      class: 'sp-results',
      style: { 'minHeight': this.dropHeight + 'px' },
      on: {
        mouseleave: function mouseleave() {
          return _this.highlight(-1);
        }
      }
    }, this.list.map(function (val, index) {
      return h('li', {
        class: _this.rowClass(val, index),
        key: index,
        attrs: {
          title: val[_this.showField] || ''
        },
        domProps: {
          innerHTML: _this.renderCell(val)
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.rowClick(val);
          },
          mouseenter: function mouseenter() {
            return _this.highlight(_this.inPicked(val) ? -1 : index);
          }
        }
      });
    }));
  }
};


//////////////////
// WEBPACK FOOTER
// ./src/component/dic/components/List.js
// module id = 14
// module chunks = 0